'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _parcelsApi = require('self-service-api/core/api/parcelsApi');

var parcelsApi = _interopRequireWildcard(_parcelsApi);

var _parcelsAdapter = require('self-service-api/adapters/parcelsAdapter');

var _parcelsAdapter2 = _interopRequireDefault(_parcelsAdapter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var getParcels = function getParcels() {
  return parcelsApi.fetchParcels().then(_parcelsAdapter2.default);
};

exports.default = getParcels;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/self-service-api/static-1.837/js/api/getParcels.js
// module id = 204
// module chunks = 3 4 5